export default __webpack_public_path__ + "static/media/covidmovile.f84797ce.png";